<template>
<div class="preview-log">
  <div class="preview-log-header">
    <el-button type="primary" @click="init" size="mini">刷新</el-button>
  </div>
  <div class="preview-log-item">
    <div class="preview-log-item-header">30天预览次数</div>
    <div class="preview-log-item-body" ref="chart1"></div>
  </div>
  <div class="preview-log-item">
    <div class="preview-log-item-header">30天各个服务被预览次数</div>
    <div class="preview-log-item-body" ref="chart2"></div>
  </div>
  <div class="preview-log-item">
    <div class="preview-log-item-header">30天业务类型被访问次数</div>
    <div class="preview-log-item-body" ref="chart3"></div>
  </div>
  <div class="preview-log-item">
    <div class="preview-log-item-header">今天预览次数（每小时）</div>
    <div class="preview-log-item-body" ref="chart4"></div>
  </div>
</div>
</template>

<script>

import OssHttp from "./common/OssHttp";
import * as echarts from "echarts";

export default {
  name: "PreviewLog",
  data() {
    return {
      chart1:null,
      chart2:null,
      chart3:null,
      chart4:null
    }
  },
  mounted() {
    this.init();
    // 响应式处理
    window.addEventListener('resize', () => {
      if(this.chart1) this.chart1.resize();
      if(this.chart2) this.chart2.resize();
      if(this.chart3) this.chart3.resize();
      if(this.chart4) this.chart4.resize();
    });
  },
  methods: {
    init(){
      this.get30Days();
      this.get30DaysAppId();
      this.get30DaysType();
      this.getTodayHour();
    },
    get30Days(){
      OssHttp.get("/oss/PreviewLog/get30Days",{},ret=>{
        if(ret.code){
          //{"msg":"","data":[{"day":"2026-01-07","count":3509},{"day":"2026-01-08","count":8395},{"day":"2026-01-09","count":7521},{"day":"2026-01-10","count":4253},{"day":"2026-01-11","count":1709},{"day":"2026-01-12","count":9069},{"day":"2026-01-13","count":8507},{"day":"2026-01-14","count":8506},{"day":"2026-01-15","count":7638},{"day":"2026-01-16","count":7101},{"day":"2026-01-17","count":5236},{"day":"2026-01-18","count":2634},{"day":"2026-01-19","count":8178},{"day":"2026-01-20","count":7240},{"day":"2026-01-21","count":7662},{"day":"2026-01-22","count":7480},{"day":"2026-01-23","count":7021},{"day":"2026-01-24","count":3455},{"day":"2026-01-25","count":2300},{"day":"2026-01-26","count":9427},{"day":"2026-01-27","count":3646}],"code":1}
          const dates = ret.data.map(item => item.day);
          const counts = ret.data.map(item => item.count);

          if(!this.chart1){
            this.chart1 = echarts.init(this.$refs.chart1);
          }
          this.chart1.setOption({
            grid:{
              top: '5%',
              left: '20px',
              right: '20px',
              bottom: '10%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              formatter: '{b}<br />预览次数: {c}'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: dates,
              axisLabel: {
                interval: 2 // 每3个标签显示一个，避免过于密集
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              }
            },
            series: [{
              data: counts,
              type: 'line',
              smooth: true, // 圆弧效果
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: {
                color: '#5cb85c',
                width: 2
              },
              itemStyle: {
                color: '#5ab1ef'
              },
              areaStyle: {
                opacity: 0.2
              }
            }]
          });
        }
      })
    },
    get30DaysAppId(){
      OssHttp.get("/oss/PreviewLog/get30DaysAppId",{},ret=>{
        if(ret.code){
          // 数据按 app_id 分组
          const groupedData = {};
          ret.data.forEach(item => {
            if (!groupedData[item.app_id]) {
              groupedData[item.app_id] = [];
            }
            groupedData[item.app_id].push(item);
          });

          // 获取所有日期
          const allDates = [...new Set(ret.data.map(item => item.day))].sort();

          // 准备图表数据
          const series = Object.keys(groupedData).map(appId => {
            // 确保每个 app_id 都有完整的日期数据，缺失的用 0 填充
            const appData = groupedData[appId];
            const dateMap = {};
            appData.forEach(item => {
              dateMap[item.day] = item.count;
            });

            const counts = allDates.map(date => dateMap[date] || 0);

            return {
              name: appId,
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: {
                width: 2
              },
              data: counts
            };
          });

          if(!this.chart2){
            this.chart2 = echarts.init(this.$refs.chart2);
          }
          this.chart2.setOption({
            grid:{
              top: '5%',
              left: '20px',
              right: '20px',
              bottom: '10%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              formatter: function(params) {
                let result = params[0].axisValue + '<br/>';
                params.forEach(param => {
                  result += param.seriesName + ': ' + param.value + '<br/>';
                });
                return result;
              }
            },
            legend: {
              type: 'scroll',
              orient: 'horizontal',
              bottom: 10,
              data: Object.keys(groupedData)
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: allDates,
              axisLabel: {
                interval: 2 // 每3个标签显示一个，避免过于密集
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              }
            },
            series: series
          });
        }
      })
    },
    get30DaysType(){
      OssHttp.get("/oss/PreviewLog/get30DaysType",{},ret=>{
        if(ret.code){
          // 数据按 type 分组
          const groupedData = {};
          ret.data.forEach(item => {
            if (!groupedData[item.type]) {
              groupedData[item.type] = [];
            }
            groupedData[item.type].push(item);
          });

          // 获取所有日期
          const allDates = [...new Set(ret.data.map(item => item.day))].sort();

          // 准备图表数据
          const series = Object.keys(groupedData).map(type => {
            // 确保每个 type 都有完整的日期数据，缺失的用 0 填充
            const typeData = groupedData[type];
            const dateMap = {};
            typeData.forEach(item => {
              dateMap[item.day] = item.count;
            });

            const counts = allDates.map(date => dateMap[date] || 0);

            return {
              name: type,
              type: 'line',
              smooth: true,
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: {
                width: 2
              },
              data: counts
            };
          });

          if(!this.chart3){
            this.chart3 = echarts.init(this.$refs.chart3);
          }
          this.chart3.setOption({
            grid:{
              top: '5%',
              left: '20px',
              right: '20px',
              bottom: '10%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              formatter: function(params) {
                let result = params[0].axisValue + '<br/>';
                params.forEach(param => {
                  result += param.seriesName + ': ' + param.value + '<br/>';
                });
                return result;
              }
            },
            legend: {
              type: 'scroll',
              orient: 'horizontal',
              bottom: 10,
              data: Object.keys(groupedData)
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: allDates,
              axisLabel: {
                interval: 2 // 每3个标签显示一个，避免过于密集
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              }
            },
            series: series
          });
        }
      })
    },
    getTodayHour(){
      OssHttp.get("/oss/PreviewLog/getTodayHour",{},ret=>{
        if(ret.code){
          //{"msg":"","data":[{"hour":0,"count":23},{"hour":1,"count":3},{"hour":2,"count":2},{"hour":7,"count":26},{"hour":8,"count":584},{"hour":9,"count":1291},{"hour":10,"count":1197},{"hour":11,"count":704}],"code":1}
          const hours = ret.data.map(item => item.hour + '时');
          const counts = ret.data.map(item => item.count);

          if(!this.chart4){
            this.chart4 = echarts.init(this.$refs.chart4);
          }
          this.chart4.setOption({
            grid:{
              top: '5%',
              left: '20px',
              right: '20px',
              bottom: '10%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              formatter: '{b}<br />预览次数: {c}'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: hours
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value}'
              }
            },
            series: [{
              data: counts,
              type: 'line',
              smooth: true, // 圆弧效果
              symbol: 'circle',
              symbolSize: 6,
              lineStyle: {
                color: '#5cb85c',
                width: 2
              },
              itemStyle: {
                color: '#5ab1ef'
              },
              areaStyle: {
                opacity: 0.2
              }
            }]
          });
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.preview-log{
  margin: 20px;
  padding: 10px;
  background-color: #f4faff;
  border-radius: 5px;

  .preview-log-header{
    margin-bottom: 10px;
  }

  .preview-log-item{
    margin-bottom: 20px;
    width: 100%;
    background-color: white;
    padding: 10px;
    border-radius: 5px;

    .preview-log-item-header{
      font-size: 20px;
      font-weight: bold;
    }
    .preview-log-item-body{
      height: 400px;
      width: calc(100% - 20px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Log/PreviewLog.vue